import React, { useEffect, useState } from "react";
import { Control, useFormState } from "react-hook-form";

import { ControlledInput } from "../../Common/Controllers";
import { getInputErrorMessage } from "../../Common/Form/service";
import { InputContainer } from "../styles";
import { RegistrationForm } from "../types";

function ProviderInputs({
  animate,
  control,
}: {
  animate: boolean;
  control: Control<{ firstName?: string; lastName?: string }>;
}) {
  const { errors } = useFormState<RegistrationForm>({ control });

  const [show, setShow] = useState(animate);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(!animate);
    }, 300);
    return () => clearTimeout(timeout);
  }, [animate]);
  return (
    <>
      {show && (
        <InputContainer $animate={animate}>
          <ControlledInput
            name="firstName"
            label="First name"
            control={control}
            // @ts-expect-error TS2322
            error={getInputErrorMessage(errors?.firstName?.message)}
          />
          <ControlledInput
            name="lastName"
            label="Last name"
            control={control}
            // @ts-expect-error TS2322
            error={getInputErrorMessage(errors?.lastName?.message)}
          />
        </InputContainer>
      )}
    </>
  );
}

// eslint-disable-next-line no-restricted-exports
export default ProviderInputs;
